import DsAutoAudit from './src/index';

/* istanbul ignore next */
DsAutoAudit.install = function(Vue) {
    Vue.component(DsAutoAudit.name, DsAutoAudit);
};

export default DsAutoAudit;
